module.exports = __webpack_public_path__ + "static/media/oberflex-poirier-2560x1440.9911dde2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-poirier-2560x1440.jpg
// module id = 1053
// module chunks = 37